import initialState from './initialState'

import {
  SET_PREFERENCE_TOOLTIPS
 } from '../actions/actionTypes'

export default function preferencesReducer(state = initialState.editorPreferences, action) {
  switch (action.type) {
    case SET_PREFERENCE_TOOLTIPS:
      return { ...state, showTooltips: action.active }

    default:
      return state
  }
}
